import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { Bone } from "./Doodles";

const STATS = [
  { value: 5, suffix: "", label: "Dog Houses Built" },
  { value: 1, suffix: "", label: "Shelters & Partners Served" },
  { value: 20, suffix: "+", label: "Student Volunteers" },
  { value: 100, suffix: "%", label: "Free — Every Single One" },
];

const Stat = ({ value, suffix, label, index }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.6,
      delay: index * 0.15,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value, index]);

  return (
    <motion.div
      ref={ref}
      data-testid={`impact-stat-${index}`}
      initial={{ opacity: 0, y: 30, rotate: index % 2 === 0 ? -1.5 : 1.5 }}
      whileInView={{ opacity: 1, y: 0, rotate: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: index * 0.12 }}
      className="flex flex-col items-center text-center"
    >
      <span className="font-display text-7xl leading-none text-[#16294B] md:text-8xl">
        {display}
        {suffix}
      </span>
      <span className="mt-3 text-sm font-semibold text-[#16294B]/80 md:text-base">{label}</span>
    </motion.div>
  );
};

const Impact = () => (
  <section data-testid="impact-section" className="relative border-b-2 border-[#16294B] bg-[#FBF3E3] py-20 md:py-24" aria-label="Project Archie impact so far">
    <motion.span
      initial={{ opacity: 0, rotate: -30 }}
      whileInView={{ opacity: 1, rotate: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      className="absolute left-6 top-6 md:left-14 md:top-10"
      aria-hidden="true"
    >
      <Bone className="h-8 w-8 md:h-10 md:w-10" color="#E63946" />
    </motion.span>
    <motion.span
      initial={{ opacity: 0, rotate: 30 }}
      whileInView={{ opacity: 1, rotate: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, delay: 0.2 }}
      className="absolute bottom-6 right-6 md:bottom-10 md:right-14"
      aria-hidden="true"
    >
      <Bone className="h-8 w-8 md:h-10 md:w-10" color="#E63946" />
    </motion.span>

    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <h2 className="sr-only">Our impact so far</h2>
      <div className="grid grid-cols-2 gap-x-6 gap-y-12 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Stat key={s.label} value={s.value} suffix={s.suffix} label={s.label} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default Impact;
